import { create } from "zustand";

import { Transactions } from "@/data/helper/getTitleByLanguage";
import { RecommendedData, RegionData } from "@/types/store/location.types";

interface ILocation {
  recommended: RecommendedData[];
  regionValue: RegionData[];
  citiesTranslations: Map<string, Transactions[]>;
  setRecommended: (value: RecommendedData[]) => void;
  setRegionValue: (value: RegionData[]) => void;
}

export const useLocationStore = create<ILocation>((set) => ({
  recommended: [],
  regionValue: [],
  citiesTranslations: new Map(),
  setRecommended: (value) => set({ recommended: value }),
  setRegionValue: (items) => {
    const citiesMap = new Map<string, Transactions[]>();

    items.forEach((region) => {
      region.cities.forEach((city) => {
        citiesMap.set(
          city.name.en,
          Object.entries(city.name).map(([language, name]) => {
            return { language, name };
          }),
        );
      });
    });

    set({ regionValue: items, citiesTranslations: citiesMap });
  },
}));
